module.exports = __webpack_public_path__ + "img/UTFHNH-1.ca0072fa.jpg";